import React, { PureComponent } from "react";
import connect from "react-redux/es/connect/connect";
import { withRouter } from "react-router-dom";
import "./welcome.css";
import logo from "../../../img/logo-conga.svg";
import { doLogout, getApiBaseURL } from "../../common";
import Button from "@salesforce/design-system-react/components/button";
import Spinner from "@salesforce/design-system-react/components/spinner";
import { RELEATIVE_PATH } from "../../../config";
import Tooltip from "@salesforce/design-system-react/components/tooltip";
import api from "../../../api";

class Welcome extends PureComponent<{}, any> {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
    };
  }

  redirectToSFLogin(isSandbox) {
    this.setState({ isLoading: true });
    doLogout();
    const requestOptions = {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    };

    if (isSandbox)
      requestOptions.headers = {
        "Content-Type": "application/json",
        OrgType: "sandbox",
      };
    api.get(getApiBaseURL() + "/Login", requestOptions)
      .then((response) => response.data)
      .then((redirectURL) => {
        var urlParams = redirectURL.substring(redirectURL.indexOf("?") + 1);
        var paramArray = urlParams.split("&");
        paramArray.forEach((element) => {
          if (element.indexOf("state") >= 0) {
            var stateId = element.split("=")[1];
            sessionStorage.setItem("state", stateId);
          }
        });
        this.setState({ isLoading: false });
        window.location.assign(redirectURL);
      });
  }

  render() {
    return (
      <div class="welcome-background-theme">


        <div class="slds-context-bar">
          <div class="slds-context-bar__primary">
            <div class="slds-context-bar__item slds-context-bar__dropdown-trigger slds-dropdown-trigger slds-dropdown-trigger_click slds-no-hover">
              <div class="slds-context-bar__icon-action">
                <img alt="Conga Logo" src={logo} />
              </div>
              <span class="slds-context-bar__label-action slds-context-bar__app-name">
                <span class="slds" title="Conga Upgrade">
                  Welcome to Conga Upgrade
                </span>
              </span>
            </div>
          </div>
        </div>

        <div class="wel-cont-div">

          <div class="org-bg"></div>
          <div class="grid-container grid-video">
            <div class="upgrade-warning">
              <p>
                <strong>Important Note: </strong>
                <i>When registering either a Sandbox or Production org for the Upgrade Program for the October 2023 Release, please also create a Technical Support case to ensure the deployment gets scheduled accurately.</i>
              </p>
            </div><br/>
            <div class="grid-child div-desc">
              <h1>Conga Upgrade Program</h1> <br />
              <strong>Unlock the latest Conga features today.</strong>
              <p class="upgrade-info"> The most efficient method to automatically upgrade your Conga CLM and/or Conga CPQ software to the latest version—at no cost to you!</p>
              <div class="btn-wrapper">
                <Button
                  className={"roundCorner"}
                  label="Register Sandbox"
                  onClick={() => this.redirectToSFLogin(true)}
                />
              </div>
              <Tooltip content={<span>If the sandbox org you are trying to register was upgraded or refreshed prior to <i>November 1st</i>, please upgrade your CLM or CPQ package or refresh it from Production before registering for the Conga Upgrade Program.</span>}>
                <p class="upgrade-info">
                  The Conga Upgrade Program requires any Sandboxes being registered to have a CLM or CPQ package upgrade or be refreshed from your Production org after <i>November 1st, 2022</i>.
                </p>
              </Tooltip>
            </div>

            <div class="grid-child">
              <div class="video-container">
                <img class="conga-img" src={RELEATIVE_PATH + "/upgrade-program-monitor-registration-page-480x480.png"} ></img>
              </div>
            </div>

          </div>

          <div class="info-container">
            <div class="info-wrapper">
              <strong>How do I start?</strong>
              <p>We recommend registering your sandbox(es) to allow for testing prior to deployment in your production org(s).​ As a best practice, Conga recommends registering your sandbox org(s) to allow for testing prior to production deployments.</p>

              <div class="btn-wrapper">
                <Button
                  className={"roundCorner"}
                  label="Register Sandbox"
                  onClick={() => this.redirectToSFLogin(true)}
                />
                <Button
                  className={"roundCorner"}
                  label="Register Production"
                  onClick={() => this.redirectToSFLogin(false)}
                />
              </div>

              <strong>What's next?</strong>
              <p>You will automatically receive Conga's release updates throughout the year per our <a href="https://documentation.conga.com/rc/product-release-calendar" target={"_blank"}><span class="conga-link">release calendar</span></a>.​​</p>

              <strong>Important to know.</strong>
              <ul class="list">
                <li>Once the sandbox deployment occurs, you'll gain access to Conga's test suite for automated testing in addition to any supplemental testing on your own​.</li>
                <li><strong>Allow 4 weeks prior</strong> to deployment to production for additional testing.</li>
              </ul>

              <strong>Who is this for?</strong>
              <p>We recommend Conga CLM and Conga CPQ customers register for Conga Upgrades to stay current with our major annual releases throughout the year.​</p>

              <strong>Can't wait?</strong>
              <p>Interested in registering your Org for the Program, but don't want to wait until the next release to Upgrade? Submit a <a href="https://conga.com/support" target={"_blank"}><span class="conga-link">technical support case</span></a> to receive your upgrade today! ​</p>

              <strong>Need help?</strong>
              <p>Have questions? Please contact your Customer Success Manager or reach out to <a href="mailto:upgrade@conga.com"><span class="conga-link">upgrade@conga.com</span></a>.​​</p>
            </div>
          </div>

          <div class="footer mx-md-n5 ">
            <div class="container">
              <section class="mb-4">
                <a
                  class="btn footer-text-rights btn-link btn-floating btn-md text-dark m-1"
                  href="#!"
                  role="button"
                  data-mdb-ripple-color="dark"
                >© 2022 All Rights Reserved</a>

                <a
                  class="btn footer-text btn-link btn-floating btn-md  m-1"
                  href="https://conga.com/privacy"
                  role="button"
                  data-mdb-ripple-color="dark"
                >Privacy</a>

                <a
                  class="btn footer-text btn-link btn-floating btn-md  m-1"
                  href="https://conga.com/legal"
                  role="button"
                  data-mdb-ripple-color="dark"
                >Legal</a>

                <a
                  class="btn footer-text btn-link btn-floating btn-md  m-1"
                  href="https://status.getconga.com/?_ga=2.150507070.928275266.1651647197-117998360.1644997137"
                  role="button"
                  data-mdb-ripple-color="dark"
                >System Status</a>

              </section>
            </div>
          </div>
        </div>

        {
          this.state.isLoading && (
            <Spinner
              size="large"
              variant="brand"
              assistiveText={{ label: "Loading..." }}
            />
          )
        }
      </div >

    );
  }
}

function mapStateToProps(state, ownProps) {
  return {};
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Welcome));
